module.exports = __webpack_public_path__ + "img/login_illustration_pump.18789a1d.png";